import React, { useEffect, useState } from 'react';
import ConfigDB from '../../Config/ThemeConfig';
import { classes } from '../../Data/Layouts';
import Context from './index';

const CustomizerProvider = (props) => {
    const customizer = ConfigDB.data
    const [toggleIcon, setToggleIcon] = useState(false);
    const [mixLayout, setMixLayout] = useState(false);
    const [IsOpen, setIsClose] = useState(false);
    const [mix_background_layout, setMixBackgroundLayout] = useState('');


    useEffect(() => {
        ConfigDB.data.settings.sidebar.type = 'compact-wrapper';
        ConfigDB.data.settings.sidebar_setting = 'default-sidebar';

    }, [])

    //Toggle sidebar
    const toggleSidebar = (toggle) => {
        console.log(toggle,'toogggledata');
        setToggleIcon(toggle);
    };

    //Add Mix layouts like (dark , light ,...)
    const addMixBackgroundLayout = (mix_background_layout) => {
        ConfigDB.data.color.mix_background_layout = mix_background_layout;
        localStorage.setItem('mix_background_layout', mix_background_layout);
        if (mix_background_layout !== 'light-only') {
            setMixLayout(false);
        } else {
            setMixLayout(true);
        }
        setMixBackgroundLayout(mix_background_layout);
    };


    return (
        <Context.Provider
            value={{
                ...props,
                toggleIcon,
                mix_background_layout,
                mixLayout,
                IsOpen,
                customizer,
                setIsClose,
                setToggleIcon,
                setMixLayout,
                toggleSidebar: toggleSidebar,
                addMixBackgroundLayout: addMixBackgroundLayout,
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default CustomizerProvider;
